// extracted by mini-css-extract-plugin
export default {"activePoint":"MenuComponent_activePoint__WQH6-","point":"MenuComponent_point__9HyaT"};